import { ISelectOption } from '../interfaces/ISelectOption';

export const federalLawNameSelectOptions: (ISelectOption<string> & { value: boolean })[] = [
  {
    id: 'ERP',
    value: false,
    label: 'ФГИС ЕРП (294, 131, 184 ФЗ)',
  },
  {
    id: 'ERKNM',
    value: true,
    label: 'ФГИС ЕРКНМ (248 ФЗ)',
  },
];
